import useJoyrideTour from '@hooks/useJoyRideTour';
import Joyride from 'react-joyride';
import { useLocation } from 'react-router-dom';

const JoyrideTour = ({ customSteps, onTourComplete }) => {
  const location = useLocation();

  const hookToUse = useJoyrideTour;

  const { steps, activeStep, isJoyrideOpen, handleJoyrideCallback, CompletionDialog } = hookToUse(
    customSteps,
    onTourComplete,
  );

  return (
    <>
      <Joyride
        steps={steps}
        run={isJoyrideOpen}
        continuous
        scrollToFirstStep={true}
        showSkipButton={activeStep !== 12}
        spotlightClicks
        locale={{
          last: 'Finish',
          next:
            activeStep === 0 && location.pathname === '/dynamic-survey/create'
              ? 'Continue Onboarding'
              : activeStep === 0 && location.pathname === '/dashboard'
                ? 'Take a tour'
                : activeStep === 1
                  ? 'Lets go'
                  : activeStep === 14
                    ? 'Finish'
                    : 'Next',
          back: 'Back',
          skip:
            activeStep === 0 && location.pathname === '/dynamic-survey/create'
              ? 'Back to Survey'
              : 'Skip tour',
        }}
        floaterProps={{ disableAnimation: true }}
        styles={{
          options: {
            primaryColor: '#4F46E5',
            zIndex: 10000,
            arrowColor: '#ffffff',
          },
          tooltip: {
            fontSize: '14px',
            padding: '10px',
          },
          tooltipContainer: {
            textAlign: 'left',
          },

          buttonNext: {
            backgroundColor: '#7D5AE8',
            fontSize: '14px',
            padding: '8px 16px',
            borderRadius: '4px',
          },
          buttonBack: {
            marginRight: '8px',
            fontSize: '14px',
            padding: '8px 16px',
          },
          buttonSkip: {
            color: '#4B5563',
            fontSize: '14px',
          },
        }}
        callback={handleJoyrideCallback}
      />
      {CompletionDialog}
    </>
  );
};

export default JoyrideTour;
